<nz-content class="page-content">
  <div class="page-content__container">
    <form nz-form novalidate *ngIf="messageLog">
      <div class="flex-row">
        <div class="dashboard__container--content-column dashboard__container--flex">
          <nz-card nzTitle="{{ 'pechkin.int-10.2.messageInfo' | translate }}" class="dashboard__card mb-10">
            <div hw-form-row>
              <hw-form-item label="{{ 'pechkin.int-10.2.id' | translate }}" name="name" *hwFormCol>
                {{ messageLog?.id }}
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item label="{{ 'pechkin.int-10.2.date' }}" name="email" *hwFormCol>
                {{ messageLog?.date | localDateTime }}
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item label="{{ 'pechkin.int-10.2.type' }}" name="phone" *hwFormCol>
                {{ messageLog?.type }}
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item label="{{ 'pechkin.int-10.2.receiver' }}" *hwFormCol>
                {{ messageLog?.receiver }}
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item label="{{ 'pechkin.int-10.2.status' }}" *hwFormCol>
                <nz-tag [nzColor]="'blue'" *ngIf="messageLog.status === 'ACCEPTED'">{{ messageLog.status }}</nz-tag>
                <nz-tag [nzColor]="'red'" *ngIf="messageLog.status === 'FAILED'">{{ messageLog.status }}</nz-tag>
                <nz-tag [nzColor]="'green'" *ngIf="messageLog.status === 'SENT'">{{ messageLog.status }}</nz-tag>
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item label="{{ 'pechkin.int-10.2.message' }}" *hwFormCol>
                {{ messageLog?.message }}
                <hw-copy-button
                  *ngIf="messageLog.message"
                  mode="icon-text"
                  [content]="messageLog?.message"></hw-copy-button>
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item label="{{ 'pechkin.int-10.2.response' }}" *hwFormCol>
                {{ messageLog?.response | json }}
                <hw-copy-button
                  *ngIf="messageLog.response"
                  mode="icon-text"
                  [content]="messageLog?.response"></hw-copy-button>
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item label="{{ 'pechkin.int-10.2.metadata' }}" *hwFormCol>
                {{ messageLog?.metadata | json }}
                <hw-copy-button
                  *ngIf="messageLog.metadata"
                  mode="icon-text"
                  [content]="messageLog?.metadata"></hw-copy-button>
              </hw-form-item>
            </div>
          </nz-card>
        </div>
      </div>
    </form>
  </div>
</nz-content>
